<template>
  <div
    class="modal"
    :class="{'is-danger': type === 'danger'}"
    aria-hidden="true"
    :id="id"
  >
    <div class="modal-overlay" tabindex="-1">
      <div
        class="modal-container"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="`${id}-title`"
      >
        <header class="modal-header" v-if="title">
          <i :class="`fas fa-${icon}-circle modal-header-icon`"></i>
          <span :id="`${id}-title`">{{ title }}</span>
        </header>
        <div class="modal-content">
          <slot></slot>
        </div>
        <div class="modal-footer">
          <template v-if="$slots.footer">
            <slot name="footer"></slot>
          </template>
          <template v-else>
            <WaveButton type="submit" size="small" :text="true" @click="$emit('ok')">OK</WaveButton>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: ""
    },
    icon: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false
    }
  }
}
</script>
